<template>

  <van-popup v-model="_value" position="bottom">
    <van-picker
            title="安装员"
            show-toolbar
            :columns="maintainerIdOptions"
            @confirm="onConfirmmaintainerId"
            @cancel="onCancelmaintainerId"
    />
  </van-popup>

</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  import {
    Cell,
    CellGroup,
    Field,
    Row,
    Col,
    Button,
    Dialog,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Picker,
    Popup,
    Divider,
    Collapse,
    CollapseItem,
    DatetimePicker,
    Tag,
    DropdownMenu,
    DropdownItem,
    Sticky,
    Icon,
    Search,
    PullRefresh,
    List,
    Loading,
    Toast,
    Uploader,
    Overlay,
    NumberKeyboard,
    Tab, Tabs
  } from 'vant'

  Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(Tab).use(Tabs)
          .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Overlay).use(NumberKeyboard)
          .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

  export default {
    name: 'maintainorderchangemaintainermodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        maintainers:[],
        maintainOrder: {
          id:null,
          maintainerId:null
        },

        /**
         * 选择安装员
         */
        maintainerId:'',
        _value: false,
        maintainerIdOptions: [],
      }
    },
    methods: {
      ...mapActions([
        'MaintainOrderServ_ChangeMaintainer',
        'UserServ_GetAllUsers',
        'MaintainOrderServ_GetDetail'
      ]),
      onConfirmmaintainerId(value, index) {
        this.maintainerId = value
        store.dispatch('UserServ_GetPage', {
          params: null,
          urlparams: {keyword: this.maintainerId}
        }).then(res => {
          console.log(res)
          if (store.getters.get_User_GetPageResult.content) {
            this.maintainOrder.maintainerId = store.getters.get_User_GetPageResult.content[0].id
            this.maintainOrder.id = this._initValue

            store.dispatch('MaintainOrderServ_ChangeMaintainer', {params: this.maintainOrder}).then(() => {
              this.$Message.success('指派维修员成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })

          }
        }).catch(err => {
        })
        this._value = false
      },
      onCancelmaintainerId() {
        this._value = false
      },
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.maintainerIdOptions = []
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8,14] }
        }).then(() => {
          if (store.getters.get_User_GetAllUsersResult) {
            store.getters.get_User_GetAllUsersResult.forEach(item => {
              this.maintainerIdOptions.push(item.realName!=null?item.realName:item.name!=null?item.name:item.nickName)
            })
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      })
    }
  }
</script>
